import config from 'constants/config'
import { getImageUrl } from 'lib/image/imageUtils'
import type { IntlShape } from 'react-intl'

const EXPERIENCES_OG_IMAGE_ID = '4d3ab866-055a-476c-91f1-63baf6e57c1a'
const EXPERIENCES_OG_IMAGE_OPTIONS = { width: 1200, aspectRatio: '16:9', format: 'jpeg' as const }

interface ExperiencesHeadMetaParams {
  placeName?: string
  isAnywhere: boolean
  intl: IntlShape
}

interface ExperiencesHeadMeta {
  title: string
  description: string
  imageId: string
  imageUrl: string
  imageAlt: string
}

export function getExperiencesSearchHeadMeta({ placeName, isAnywhere, intl }: ExperiencesHeadMetaParams): ExperiencesHeadMeta {
  const effectivePlaceName = placeName?.trim()
  const hasPlace = !!effectivePlaceName && !isAnywhere

  const title = hasPlace
    ? intl.formatMessage(
        {
          id: 'QEXXKigOzN51_MogxBx0',
          defaultMessage: 'Browse our best handpicked experiences in {placeName}',
          description: 'SEO page title for experience search results with a specific place',
        },
        { placeName: effectivePlaceName },
      )
    : intl.formatMessage({
        id: '0_LhNOYLR8pZnkyzU8wp',
        defaultMessage: 'Browse our best handpicked experiences',
        description: 'SEO page title for experience search results without a specific place',
      })

  const description = hasPlace
    ? intl.formatMessage(
        {
          id: '5T3TGFY2j8WoDIEpgDJd',
          defaultMessage: 'Discover unforgettable experiences in {placeName} with {brandName}.',
          description: 'SEO meta description for experience search results with a specific place',
        },
        { placeName: effectivePlaceName, brandName: config.title },
      )
    : intl.formatMessage(
        {
          id: '0PWuY-8MVawzjauD31tn',
          defaultMessage: 'Discover unforgettable experiences with {brandName}.',
          description: 'SEO meta description for experience search results without a specific place',
        },
        { brandName: config.title },
      )

  const imageAlt = hasPlace
    ? intl.formatMessage(
        {
          id: '7ZcmXki2I3igOLz-Uz-V',
          defaultMessage: '{placeName} experiences',
          description: 'Alt text for SEO image on experience search results with a specific place',
        },
        { placeName: effectivePlaceName },
      )
    : intl.formatMessage(
        {
          id: 'w7XMwZvHhDgqq-Mrz-2Y',
          defaultMessage: '{brandName} experiences',
          description: 'Alt text for SEO image on experience search results without a specific place',
        },
        { brandName: config.title },
      )

  return {
    title,
    description,
    imageId: EXPERIENCES_OG_IMAGE_ID,
    imageUrl: getImageUrl(EXPERIENCES_OG_IMAGE_ID, EXPERIENCES_OG_IMAGE_OPTIONS),
    imageAlt,
  }
}

export { EXPERIENCES_OG_IMAGE_ID }
